import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import axios from "axios"; import Cookies from "js-cookie";

import {Button} from "primereact/button";
import moment from "moment";

const HelpShowComponent = (props) => {

  const {t} = props;
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (window.App.state.propsHelp && window.App.state.propsHelp.id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/help-badge/" + window.App.state.propsHelp.id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {t('help_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button"
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    window.App.setState({
                      sidebarHelpShow: false,
                      sidebarHelpForm: true,
                    })
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    window.App.setState({
                      sidebarHelpShow: false,
                    })
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      <Panel className={"p-mt-3"}>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6 p-col-align-center"}>
            <h2 className={"p-m-0"}>{t('help_show')}</h2>
          </div>
          <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>

          </div>
        </div>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-12"}>
            <div className="p-field p-fluid">
              <label htmlFor="message">{t('message')}</label>
              <span className="p-d-block p-text-bold">
                {formData.message}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="type">{t('type')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.type?.toLowerCase())}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="level">{t('level')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.level?.toLowerCase())}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="box">{t('box')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.box?.toLowerCase())}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="position">{t('position')}</label>
              <span className="p-d-block p-text-bold">
                {t(formData?.position?.toLowerCase())}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="url">{t('url')}</label>
              <span className="p-d-block p-text-bold">
                {/*<i className={"pi pi-window-maximize"}*/}
                {/*   style={{cursor: 'pointer'}}*/}
                {/*   onClick={(e) => {*/}
                {/*     window.open(process.env.REACT_APP_APP_PROTOCOL + Cookies.get('subdomain') + '.'*/}
                {/*       + process.env.REACT_APP_APP_HOST.replace('#/', '#') + formData.url)*/}
                {/*   }}*/}
                {/*></i>*/}
                {/*&nbsp;*/}
                {formData.url}
              </span>
            </div>
          </div>
          <div className={"p-col-12 p-lg-4"}>
            <div className="p-field p-fluid">
              <label htmlFor="form_field">{t('form_field')}</label>
              <span className="p-d-block p-text-bold">
                {formData.form_field}
              </span>
            </div>
          </div>

        </div>
      </Panel>
    </>
  )
}
export default withTranslation('common')(HelpShowComponent);
